<template>
  <div class="container">
    <BaseCarouselCenter
      :items-carousel="agrupaciones"
      :is-loading="!agrupaciones"
      :autoplay-time="2500"
      :max-elements="3.5">
      <template #title>
        {{ $t('home.experiencias.title') }}
      </template>
      <template #itemCarousel="itemCarouselProps">
        <TarjetaHomeMejoresAgrupaciones :agrupacion="itemCarouselProps.data" />
      </template>
    </BaseCarouselCenter>
  </div>
</template>

<script setup>
  import BaseCarouselCenter from '@/components/Carousel/BaseCarouselCenter.vue';
  import TarjetaHomeMejoresAgrupaciones from '@/components/tarjetas/TarjetaHomeMejoresAgrupaciones.vue';

  defineProps({
    agrupaciones: {
      type: Array,
      required: true,
    },
  });
</script>

<style lang="css" scoped>
  .container {
    max-width: 100vw;
  }
</style>
